"use client";

import "./product-bundles";

/**
 * Renders nothing — it exists so the product routes' client chunk retains the
 * import above, which is what registers the namespaces in the browser for the
 * sections that are client components.
 */
export default function ProductI18n() {
  return null;
}
